/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createMobileListingPayment} from '../api'

export const useMutationCreateMobileListingPayment = createReactQueryMutationHook('createMobileListingPayment', createMobileListingPayment)
